import {CommentVI} from "./comment/vi";
import {EditorVI} from "./editor/vi";
import {DocumentVI} from "./document/vi";
import {ActionBarVI} from "./action-bar/vi";

export const CommonVI = {
    "common": {

        "noExists": "Không tồn tại",
        "noData" : "Chưa có dữ liệu",

        "description": "Mô tả",
        "btn": {
            "delete": "Xóa",
            "cancel": "Hủy bỏ"
        },

        "goBackModal": "Bạn có muốn giữ lại trang sau khi thực hiện thành công?",


        "required": "là yêu cầu",
        "showAgain": "Không hiển thị lại",
        "all": "Tất cả",

        "add": "Tạo mới",
        "update": "Cập nhật",
        "delete": "Xóa",
        "create": "Tạo mới",
        "cancel": "Hủy",
        "yes": "Có",
        "no": "Không",
        "addField": "Thêm trường",
        "addAndSend": "Tạo và gửi",
        "updateAndSend": "Cập nhật và gửi",
        "enable": "Cho phép",
        "disable": "Không cho phép",
        "approvalButton": "Duyệt",
        "back": "Quay về",
        "backHome" : "Quay về trang chủ ",
        "title403" : "Bạn không có quyền truy cập trang !",
        "title404" : "Trang truy cập không tồn tại !",
        "title500" : "Đã có lỗi xảy ra , chúng tôi sẽ sớm khắc phục. Vui lòng thử lại sau !",

        "validate": {
            "required": "được yêu cấu",
        },
        working : "Đang làm việc",
        waiting : "Chờ nhận việc",
        dropTemp : "Nghỉ tạm thời",
        resignation : "Đã nghỉ",
        "pending": "Chưa duyệt",
        "approved": "Đã duyệt",
        "trashed": "Đã xóa",
        "actived": "Hoạt động",
        "inactive": "Không hoạt động",
        "active": "Hoạt động",
        "activing": "Đang hoạt động",
        "inactived": "Không hoạt động",
        "expired": "Hết hiệu lực",
        "denied": "Từ chối",
        "incomplete": "Chưa hoàn thành",
        "doing": "Đang thực hiện",
        "unevaluated": "Chờ đánh giá",
        "evaluated": "Đã đánh giá",
        "draft": "Bản nháp",
        "storage": "Lưu trữ",
        "status": "Trạng thái",
        "changed": "Thay đổi",

        "message": {
            "add": "Tạo mới thành công",
            "update": "Cập nhật thành công",
            "delete": "Xóa thành công",
            "deleteAsk": "Bạn có chắc chắn muốn xóa?"
        },
        "labelCurrent": {
            "null": "Không có"
        }
    },
    ...CommentVI,
    ...EditorVI,
    ...DocumentVI,
    ...ActionBarVI
}

